import MagicWand from './src/magic-wand-combined';
export default MagicWand;